import React from 'react';
import {
	Box,
	Grid,
	Switch,
	FormControlLabel,
	Slider,
	TextField,
	InputLabel,
	MenuItem,
	FormControl,
	Select,
	Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { colorValues } from '../../colorValues';
import { additions } from '../../additions';
import { useSnapshot } from 'valtio';

const Field = (props) => {
	const { state, parentId, ...field } = props;
	const stateKey = parentId + '_' + field.id;
	const snap = useSnapshot(state);
	const useStyles = makeStyles({
		root: {
			width: 250
		},
		input: {
			width: 48,
			position: 'relative',
			top: -18
		},
		unit: {
			width: 20,
			position: 'relative',
			whiteSpace: 'nowrap',
			top: -18
		},
		formControlSelect: {
			width: '100%'
		},
		formControl: {
			width: '100%',
			'& .MuiInputLabel-root': {
				color: '#ffffff !important',
				backgroundColor: 'rgba(0,0,0,0.7)',
				padding: '0px 3px',
				marginLeft: '-2px'
			}
		},
		label: {
			'& .MuiFormControlLabel-label': {
				fontSize: '0.875rem',
				fontWeight: '500'
			}
		},
		menuItem: {
			transition: 'all 0.2s linear',
			'&:hover': {
				paddingLeft: 25
			}
		}
	});

	const classes = useStyles();
	let value = snap[stateKey];

	const syncLeanToWraps = (pid) => {
		let syncFront = false;
		let syncLeft = false;
		let syncBack = false;
		let syncRight = false;

		if (pid === 'front') {
			if (
				state.lean_to_wrap_front_left ||
				(state.lean_to_wrap_front_right && state.lean_to_wrap_back_left && state.lean_to_wrap_back_right)
			) {
				syncLeft = true;
			}
			if (
				state.lean_to_wrap_front_right ||
				(state.lean_to_wrap_front_left && state.lean_to_wrap_back_right && state.lean_to_wrap_back_left)
			) {
				syncRight = true;
			}
			if (
				(state.lean_to_wrap_front_left && state.lean_to_wrap_back_right) ||
				(state.lean_to_wrap_front_right && state.lean_to_wrap_back_left)
			) {
				syncBack = true;
			}
		} else if (pid === 'left') {
			if (
				state.lean_to_wrap_back_right ||
				(state.lean_to_wrap_front_left && state.lean_to_wrap_front_right && state.lean_to_wrap_back_left)
			) {
				syncBack = true;
			}
			if (
				state.lean_to_wrap_front_left ||
				(state.lean_to_wrap_back_right && state.lean_to_wrap_back_left && state.lean_to_wrap_front_right)
			) {
				syncFront = true;
			}
			if (
				(state.lean_to_wrap_back_right && state.lean_to_wrap_back_left) ||
				(state.lean_to_wrap_front_left && state.lean_to_wrap_front_right)
			) {
				syncRight = true;
			}
		} else if (pid === 'back') {
			if (
				state.lean_to_wrap_back_left ||
				(state.lean_to_wrap_back_right && state.lean_to_wrap_front_left && state.lean_to_wrap_front_right)
			) {
				syncRight = true;
			}
			if (
				state.lean_to_wrap_back_right ||
				(state.lean_to_wrap_back_left && state.lean_to_wrap_front_right && state.lean_to_wrap_front_left)
			) {
				syncLeft = true;
			}
			if (
				(state.lean_to_wrap_back_left && state.lean_to_wrap_front_right) ||
				(state.lean_to_wrap_back_right && state.lean_to_wrap_front_left)
			) {
				syncFront = true;
			}
		} else if (pid === 'right') {
			if (
				state.lean_to_wrap_front_right ||
				(state.lean_to_wrap_back_left && state.lean_to_wrap_back_right && state.lean_to_wrap_front_left)
			) {
				syncFront = true;
			}
			if (
				state.lean_to_wrap_back_left ||
				(state.lean_to_wrap_front_right && state.lean_to_wrap_front_left && state.lean_to_wrap_back_right)
			) {
				syncBack = true;
			}
			if (
				(state.lean_to_wrap_front_left && state.lean_to_wrap_front_right) ||
				(state.lean_to_wrap_back_left && state.lean_to_wrap_back_right)
			) {
				syncLeft = true;
			}
		}

		if (syncFront) {
			state.front_lean_to_drop = state[pid + '_lean_to_drop'];
			state.front_lean_to_length = state[pid + '_lean_to_length'];
			state.front_lean_to_pitch = state[pid + '_lean_to_pitch'];
		}
		if (syncLeft) {
			state.left_lean_to_drop = state[pid + '_lean_to_drop'];
			state.left_lean_to_length = state[pid + '_lean_to_length'];
			state.left_lean_to_pitch = state[pid + '_lean_to_pitch'];
		}
		if (syncBack) {
			state.back_lean_to_drop = state[pid + '_lean_to_drop'];
			state.back_lean_to_length = state[pid + '_lean_to_length'];
			state.back_lean_to_pitch = state[pid + '_lean_to_pitch'];
		}
		if (syncRight) {
			state.right_lean_to_drop = state[pid + '_lean_to_drop'];
			state.right_lean_to_length = state[pid + '_lean_to_length'];
			state.right_lean_to_pitch = state[pid + '_lean_to_pitch'];
		}
	};

	const handleLeanToSliderChange = (event, v, pid, fid) => {
		if (v === '') {
			v = Number(field.value);
		} else if (v < field.min) {
			v = field.min;
		} else if (v > field.max) {
			v = field.max;
		}

		state[stateKey] = v;

		syncLeanToWraps(pid);
	};

	const handleSliderChange = (event, v) => {
		if (v === '') {
			v = Number(field.value);
		} else if (v < field.min) {
			v = field.min;
		} else if (v > field.max) {
			v = field.max;
		}

		// setValue(v);
		state[stateKey] = v;
	};

	const handleMultiSelectPositionChange = (i, key, event) => {
		let temp = [];

		value.map((el, k) => {
			let q = { value: el.value, x: el.x, y: el.y };
			if (k === i) {
				q[key] = event.target.value;
			}
			temp.push(q);
		});

		state[stateKey] = temp;
	};

	const handleMultiSelectChange = (i, style, event) => {
		let temp = [];
		let saved = false;

		if (value.length > 0) {
			value.map((el, k) => {
				let q = { value: el.value, x: el.x, y: el.y };
				if (k === i) {
					if (event.target.value !== 'none') {
						console.log(event.target.value);
						q.value = event.target.value;
						if (style === 'window' || style === 'double_window') {
							q.y = 5;
						} else {
							q.y = 0;
						}
						temp.push(q);
					}
					saved = true;
				} else {
					temp.push(q);
				}
			});
		}
		console.log(temp);

		if (!saved) {
			if (event.target.value !== 'none') {
				let d = { value: '', x: 0, y: 0 };
				if (style === 'window' || style === 'double_window') {
					d.y = 5;
				}
				d.value = event.target.value;
				temp.push(d);
			}
		}

		state[stateKey] = temp;
	};

	const handleSelectChange = (event) => {
		value = event.target.value;
		state[stateKey] = value;
	};

	const handleTextChange = (event) => {
		value = event.target.value;
		state[stateKey] = value;
	};

	const handleLeanToEnableChange = (leftId, rightId, event) => {
		value = event.target.checked ? true : false;
		state[stateKey] = value;
		state[leftId] = false;
		state[rightId] = false;
	};

	const handleLeanToWrapChange = (wrapId, wrapValue, pid, event) => {
		wrapValue = !wrapValue ? true : false;
		state[wrapId] = wrapValue;

		if (wrapId === 'lean_to_wrap_front_left') {
			state.front_lean_to_enable = true;
			state.left_lean_to_enable = true;
			state.front_lean_to_cut_2 = 0;
			state.left_lean_to_cut_1 = 0;
			syncLeanToWraps(pid);
		} else if (wrapId === 'lean_to_wrap_front_right') {
			state.front_lean_to_enable = true;
			state.right_lean_to_enable = true;
			state.front_lean_to_cut_1 = 0;
			state.right_lean_to_cut_1 = 0;
			syncLeanToWraps(pid);
		} else if (wrapId === 'lean_to_wrap_back_left') {
			state.back_lean_to_enable = true;
			state.right_lean_to_enable = true;
			state.back_lean_to_cut_2 = 0;
			state.right_lean_to_cut_2 = 0;
			syncLeanToWraps(pid);
		} else if (wrapId === 'lean_to_wrap_back_right') {
			state.back_lean_to_enable = true;
			state.left_lean_to_enable = true;
			state.back_lean_to_cut_1 = 0;
			state.left_lean_to_cut_2 = 0;
			syncLeanToWraps(pid);
		}
	};

	const handleSwitchChange = (event) => {
		value = event.target.checked ? true : false;
		state[stateKey] = value;
	};

	/*const handleBlur = () => {
		if ( value === '' ) {
			value = Number(field.value);
		} else if (value < field.min) {
			value = field.min;
		} else if (value > field.max) {
			value = field.max;
		}

		state.[stateKey] = value;
	};*/

	const fieldId = 'input-slider-' + field.id;

	let fieldTypeMultiSelect = [];
	let fieldTypeSlider = '';
	let fieldTypeLeanToSlider = null;
	let fieldTypeColor = '';
	let fieldTypeSelect = '';
	let fieldTypeText = '';
	let fieldTypeToggle = '';
	let fieldTypeLeanToToggle = [];

	if (field.type === 'select') {
		if (field.id === 'ridge_vent_mode' && snap['ridge_vent_ridge_vent_type'] === 'none') {
			fieldTypeSelect = '';
		} else {
			fieldTypeSelect = (
				<Box sx={{ mt: 2 }}>
					<FormControl variant="outlined" className={classes.formControlSelect}>
						<InputLabel id={field.id + '-label'}>{field.label}</InputLabel>
						<Select
							required={field.required}
							labelId={field.id + '-select-label'}
							id={field.id + '-select'}
							value={value}
							onChange={handleSelectChange}
							label={field.label}
						>
							{field.values.map((option) => (
								<MenuItem key={option.id} value={option.id}>
									{option.label}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
			);
		}
	}

	if (field.type === 'lean_to_toggle') {
		let leftId = '';
		let rightId = '';

		if (stateKey === 'front_lean_to_enable') {
			leftId = 'lean_to_wrap_front_left';
			rightId = 'lean_to_wrap_front_right';
		} else if (stateKey === 'left_lean_to_enable') {
			leftId = 'lean_to_wrap_back_right';
			rightId = 'lean_to_wrap_front_left';
		} else if (stateKey === 'back_lean_to_enable') {
			leftId = 'lean_to_wrap_back_left';
			rightId = 'lean_to_wrap_back_right';
		} else if (stateKey === 'right_lean_to_enable') {
			leftId = 'lean_to_wrap_front_right';
			rightId = 'lean_to_wrap_back_left';
		}

		fieldTypeLeanToToggle.push(
			<Box key={field.id + '-box'} sx={{ mt: 2 }}>
				<FormControlLabel
					className={classes.label}
					control={
						<Switch
							color="primary"
							checked={value}
							onChange={(e) => handleLeanToEnableChange(leftId, rightId, e)}
							name={field.id}
						/>
					}
					label={field.label}
				/>
			</Box>
		);

		if (value) {
			let leanToWrapLeftValue = snap[leftId];
			let leanToWrapRightValue = snap[rightId];

			fieldTypeLeanToToggle.push(
				<Box key={field.id + '-left-box'} sx={{ mt: 2 }}>
					<FormControlLabel
						className={classes.label}
						control={
							<Switch
								color="primary"
								checked={leanToWrapLeftValue}
								onChange={(e) => handleLeanToWrapChange(leftId, leanToWrapLeftValue, parentId, e)}
								name={leftId}
							/>
						}
						label="Wrap Left"
					/>
				</Box>
			);
			fieldTypeLeanToToggle.push(
				<Box key={field.id + '-right-box'} sx={{ mt: 2 }}>
					<FormControlLabel
						className={classes.label}
						control={
							<Switch
								color="primary"
								checked={leanToWrapRightValue}
								onChange={(e) => handleLeanToWrapChange(rightId, leanToWrapRightValue, parentId, e)}
								name={rightId}
							/>
						}
						label="Wrap Right"
					/>
				</Box>
			);
		}
	}

	if (field.type === 'toggle') {
		fieldTypeToggle = (
			<Box sx={{ mt: 2 }}>
				<FormControlLabel
					className={classes.label}
					control={<Switch color="primary" checked={value} onChange={handleSwitchChange} name={field.id} />}
					label={field.label}
				/>
			</Box>
		);
	}

	if (field.type === 'text') {
		fieldTypeText = (
			<Box sx={{ mt: 2 }}>
				<TextField
					fullWidth
					required={field.required}
					id={field.id + '-text'}
					label={field.label}
					value={value}
					onChange={handleTextChange}
					variant="outlined"
				/>
			</Box>
		);
	}

	if (field.type === 'multi_select') {
		let k = 0;
		let keys = Object.keys(additions);
		let style = null;

		value.map((el, i) => {
			if (el.value !== 'none') {
				style = additions[el.value].style;
				fieldTypeMultiSelect.push(
					<Box key={field.id + '-multi-select-box-' + i} sx={{ mt: 2 }}>
						<FormControl key={field.id + '-multi-select-' + i} variant="outlined" className={classes.formControlSelect}>
							<InputLabel id={field.id + '-label'}>{field.label}</InputLabel>
							<Select
								labelId={field.id + '-multi-select-' + i + '-label'}
								id={field.id + '-multi-select-' + i}
								value={el.value}
								onChange={(e) => handleMultiSelectChange(i, additions[e.target.value].style, e)}
								label={field.label}
							>
								{keys.map((key) => (
									<MenuItem key={additions[key].id} value={additions[key].id}>
										{additions[key].label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
				);
				fieldTypeMultiSelect.push(
					<Box key={field.id + '-multi-select-' + i + '-position-x-slider-box'} sx={{ mt: 2 }}>
						<Typography id={field.id + '-multi-select-' + i + '-position-x-slider'} variant="subtitle2" gutterBottom>
							Horizontal Offset
						</Typography>
						<Grid container spacing={1} alignItems="center">
							<Grid item xs={9}>
								<Slider
									value={el.x}
									step={1}
									min={-100}
									max={100}
									onChange={(e) => handleMultiSelectPositionChange(i, 'x', e)}
									aria-labelledby={field.id + '-multi-select-' + i + '-position-x-slider'}
								/>
							</Grid>
							<Grid item xs={3}>
								<Typography variant="subtitle2" className={classes.unit}>
									{el.x}&nbsp;ft.
								</Typography>
							</Grid>
						</Grid>
					</Box>
				);
				if (style === 'window' || style === 'double_window') {
					fieldTypeMultiSelect.push(
						<Box key={field.id + '-multi-select-' + i + '-position-y-slider-box'} sx={{ mt: 2 }}>
							<Typography id={field.id + '-multi-select-' + i + '-position-y-slider'} variant="subtitle2" gutterBottom>
								Vertical Offset
							</Typography>
							<Grid container spacing={1} alignItems="center">
								<Grid item xs={9}>
									<Slider
										value={el.y}
										step={1}
										min={0}
										max={40}
										onChange={(e) => handleMultiSelectPositionChange(i, 'y', e)}
										aria-labelledby={field.id + '-multi-select-' + i + '-position-y-slider'}
									/>
								</Grid>
								<Grid item xs={3}>
									<Typography variant="subtitle2" className={classes.unit}>
										{el.y}&nbsp;ft.
									</Typography>
								</Grid>
							</Grid>
						</Box>
					);
				}
			}
			k = i;
		});

		let additionOptions = [];
		keys.map((key) => {
			if (key !== 'none') {
				additionOptions.push(
					<MenuItem key={additions[key].id} value={additions[key].id}>
						{additions[key].label}
					</MenuItem>
				);
			}
		});
		k++;
		if (k < 7) {
			fieldTypeMultiSelect.push(
				<Box key={field.id + '-multi-select-box-' + k} sx={{ mt: 2 }}>
					<FormControl key={field.id + '-multi-select-' + k} variant="outlined" className={classes.formControlSelect}>
						<InputLabel id={field.id + '-label'}>{field.label}</InputLabel>
						<Select
							labelId={field.id + '-select-label'}
							id={field.id + '-select'}
							value=""
							onChange={(e) => handleMultiSelectChange(k, additions[e.target.value].style, e)}
							label={field.label}
						>
							{additionOptions}
						</Select>
					</FormControl>
				</Box>
			);
		}
	}

	if (field.type === 'lean_to_slider') {
		let showLeanToField = true;

		if (parentId === 'front' && !snap.front_lean_to_enable) {
			showLeanToField = false;
		} else if (parentId === 'left' && !snap.left_lean_to_enable) {
			showLeanToField = false;
		} else if (parentId === 'back' && !snap.back_lean_to_enable) {
			showLeanToField = false;
		} else if (parentId === 'right' && !snap.right_lean_to_enable) {
			showLeanToField = false;
		}

		if (showLeanToField) {
			if (field.id == 'lean_to_cut_1' || field.id == 'lean_to_cut_2') {
				if (
					(stateKey === 'front_lean_to_cut_1' && snap.lean_to_wrap_front_right) ||
					(stateKey === 'front_lean_to_cut_2' && snap.lean_to_wrap_front_left) ||
					(stateKey === 'left_lean_to_cut_1' && snap.lean_to_wrap_front_left) ||
					(stateKey === 'left_lean_to_cut_2' && snap.lean_to_wrap_back_right) ||
					(stateKey === 'back_lean_to_cut_1' && snap.lean_to_wrap_back_left) ||
					(stateKey === 'back_lean_to_cut_2' && snap.lean_to_wrap_back_right) ||
					(stateKey === 'right_lean_to_cut_1' && snap.lean_to_wrap_front_right) ||
					(stateKey === 'right_lean_to_cut_2' && snap.lean_to_wrap_back_left)
				) {
					showLeanToField = false;
				}
			}
		}

		if (showLeanToField) {
			fieldTypeLeanToSlider = (
				<Box sx={{ mt: 0 }}>
					{field.heading && (
						<Typography sx={{ mt: 2 }} variant="h6" gutterBottom>
							{field.heading}
						</Typography>
					)}
					<Typography id={fieldId} variant="subtitle2" gutterBottom>
						{field.label}
					</Typography>
					<Grid container spacing={1} alignItems="center">
						<Grid item xs={9}>
							<Slider
								value={typeof value === 'number' ? value : 0}
								step={field.step}
								min={field.min}
								max={field.max}
								onChange={(e, v) => handleLeanToSliderChange(e, v, parentId, field.id)}
								aria-labelledby={fieldId}
							/>
						</Grid>
						{field.units && (
							<Grid item xs={3}>
								<Typography variant="subtitle2" className={classes.unit}>
									{typeof value === 'number' ? value : 0}
									{field.units !== '/12' ? ' ' : ''}
									{field.units}
								</Typography>
							</Grid>
						)}
					</Grid>
				</Box>
			);
		}
	}

	if (field.type === 'slider') {
		fieldTypeSlider = (
			<Box sx={{ mt: 0 }}>
				{field.heading && (
					<Typography sx={{ mt: 2 }} variant="h6" gutterBottom>
						{field.heading}
					</Typography>
				)}
				<Typography id={fieldId} variant="subtitle2" gutterBottom>
					{field.label}
				</Typography>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs={9}>
						<Slider
							value={typeof value === 'number' ? value : 0}
							step={field.step}
							min={field.min}
							max={field.max}
							onChange={handleSliderChange}
							aria-labelledby={fieldId}
						/>
					</Grid>
					{field.units && (
						<Grid item xs={3}>
							<Typography variant="subtitle2" className={classes.unit}>
								{typeof value === 'number' ? value : 0}
								{field.units !== '/12' ? ' ' : ''}
								{field.units}
							</Typography>
						</Grid>
					)}
				</Grid>
			</Box>
		);
	}

	if (field.type === 'color') {
		if (field.id === 'color_wainscot' && !snap['building_options_wainscot']) {
			fieldTypeColor = '';
		} else {
			fieldTypeColor = (
				<Box sx={{ mt: 2 }}>
					<FormControl className={classes.formControl}>
						<InputLabel id={field.id + '-label'}>{field.label}</InputLabel>
						<Select
							labelId={field.id + '-select-label'}
							id={field.id + '-select'}
							value={value}
							onChange={handleSelectChange}
							label={field.label}
							style={{ backgroundColor: '' + value }}
						>
							{colorValues.map((color) => (
								<MenuItem
									key={color.id}
									style={{ backgroundColor: '' + color.hex }}
									className={classes.menuItem}
									value={color.hex}
								>
									{color.label}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
			);
		}
	}

	return (
		<>
			<Box
				sx={{
					backgroundColor: 'background.paper',
					minHeight: '0',
					p: 0,
					mt: 2
				}}
			>
				{fieldTypeMultiSelect}
				{fieldTypeSlider}
				{fieldTypeLeanToSlider}
				{fieldTypeToggle}
				{fieldTypeLeanToToggle}
				{fieldTypeColor}
				{fieldTypeSelect}
				{fieldTypeText}
			</Box>
		</>
	);
};

export default Field;
